import LimeProductResponse from '../../controllers/LimeProductResponse'
import {FieldStatus, getFieldConfig} from './GetFieldConfig'
import {roundTo} from '../program/ViewBlock'

export type ChemicalFieldKey = keyof ReturnType<typeof getFieldConfig>

export interface ChemicalField {
    key: ChemicalFieldKey
    label: string
    tableHeader?: string
    percent: boolean
}

// The chemical characteristics captured when creating a lime product. Which of these
// are shown/required for a given product is driven by getFieldConfig(type).
export const chemicalFields: ChemicalField[] = [
    {key: 'caPercent', label: '% Ca', percent: true},
    {key: 'caCO3Percent', label: '% CaCO3', percent: true},
    {key: 'caOPercent', label: '% CaO', percent: true},
    {key: 'caSO4Percent', label: '% CaSO4', percent: true},
    {key: 'mgPercent', label: '% Mg', percent: true},
    {key: 'mgCO3Percent', label: '% MgCO3', percent: true},
    {key: 'mgOPercent', label: '% MgO', percent: true},
    {key: 'ccePercent', label: '% CCE', percent: true},
    {key: 'sPercent', label: '% S', percent: true},
    {key: 'pPercent', label: '% P', percent: true},
    {key: 'kPercent', label: '% K', percent: true},
    {key: 'ph', label: 'pH', percent: false},
    {key: 'caMgRatio', label: 'Ca:Mg Ratio', tableHeader: 'Ca:Mg', percent: false},
    {key: 'fineness', label: 'Fineness', percent: false},
]

// Format a single characteristic for display: hidden fields and nulls render as '-',
// percent fields are scaled from fraction (0-1) to whole percent.
export const formatProductField = (
    item: LimeProductResponse,
    field: ChemicalFieldKey,
    percent: boolean,
    decimals: number = 3
): string => {
    const config = getFieldConfig(item.type)
    if (config[field] === FieldStatus.Hidden) return '-'
    const value = item[field] as number | null
    if (value === null || value === undefined) return '-'
    const display = percent ? value * 100 : value
    return roundTo(display, decimals).toString()
}

// The characteristics relevant to a product's type (i.e. not hidden for that type).
export const visibleChemicalFields = (type: LimeProductResponse['type']): ChemicalField[] => {
    const config = getFieldConfig(type)
    return chemicalFields.filter(f => config[f.key] !== FieldStatus.Hidden)
}
